<section class="groupDropdown">
  <header>
    <h6>
      {{ 'group_by' | ppTranslate }}
      <pp-info-icon
        ppClass="setSize14"
        ppTooltip
        [ppOptions]="{ placement: 'right' }"
        [ppMobileTooltip]="true"
        [ppSanitize]="false"
        [ppTitle]="'group_points_description' | ppTranslate"
      />
    </h6>

    <pp-saved-view-preview-header
      [ppHideText]="false"
      [ppWorkspaceId]="siteId"
      (ppSaveToCurrentView)="saveGroupsToView()"
      [ppProcessing]="saveViewProcessing()"
    ></pp-saved-view-preview-header>
  </header>

  <div class="groupDropdown__table" (scroll)="scrollHandler($event)">
    <div
      class="groupDropdown__content"
      cdkDropList
      cdkDropListOrientation="vertical"
      (cdkDropListDropped)="dropGrouping($event)"
    >
      @if (!grouping().length && !emptyGroupsVisible().length) {
        <h6 class="groupDropdown__content_empty">
          {{ 'no_grouping_applied' | ppTranslate }}
        </h6>
      }

      @for (column of grouping(); track column; let index = $index) {
        <div
          class="groupDropdownItem--grab"
          [attr.data-testid]="'groupRow-' + column.name"
          cdkDrag
          [cdkDragData]="column"
        >
          <div class="groupDropdown__row">
            <pp-icon
              [ppSVG]="iconMap[EIconPath.ICON_DRAG_18]"
              ppColor="grey-400"
              ppClass="setSize18"
              cdkDragHandle
            ></pp-icon>
            <p class="groupDropdown__header">
              {{ (index === 0 ? 'group_by' : 'then_by') | ppTranslate }}
            </p>
            <pp-group-or-sort-button-column
              ppType="group"
              [ppColumn]="column"
              (ppUpdate)="updateColumn($event, column)"
            ></pp-group-or-sort-button-column>
            <pp-group-or-sort-button-order
              [ppColumn]="column"
              (ppUpdate)="updateOrder($event, column)"
            ></pp-group-or-sort-button-order>
            <pp-icon
              [ppSVG]="iconMap[EIconPath.ICON_CLOSE_18]"
              class="groupDropdown__close-icon setSize18"
              ppColor="grey-400"
              (click)="deleteGroup(column)"
            ></pp-icon>
          </div>
        </div>
      }

      @for (_ of emptyGroupsVisible(); track _) {
        <pp-new-group-or-sort-column
          [ppOrder]="grouping().length + 1"
          (ppAddGroup)="updateEmptyGroupColumn($event)"
          (ppCancel)="deleteEmptyGroup()"
          ppType="group"
          data-test="newGroupRow"
        ></pp-new-group-or-sort-column>
      }
    </div>
  </div>

  <hr />

  <footer>
    <pp-add-group-or-sort-button
      data-test="addEmptyGroupButton"
      [ppText]="'add_grouping_condition' | ppTranslate"
      (ppAction)="addEmptyGroup()"
      [ppDisabled]="grouping().length + emptyGroupsVisible().length >= 3"
    ></pp-add-group-or-sort-button>

    <div class="groupDropdown__buttons">
      <pp-button
        [ppTooltipTitle]="'reset_grouping' | ppTranslate"
        ppStyle="text"
        ppId="resetGroupingBtn"
        (ppAction)="clearAll()"
      >
        {{ 'clear_all' | ppTranslate }}
      </pp-button>

      <pp-button ppStyle="primary" ppId="closeGroupingBtn" (ppAction)="hideDropdown()">
        {{ 'done' | ppTranslate }}
      </pp-button>
    </div>
  </footer>
</section>
